import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Modal,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  TablePagination,
  Backdrop,
  Tabs,
  Tab,
  FormHelperText,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import { Add, Download, Edit, Logout, RemoveRedEye } from "@mui/icons-material";

import api from "../services/api";
import { clearLocalStorage, getLocalStorage } from "../utils/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  setDashBoardPageNumber,
  setDashboardSearchValue,
  setDashBoardTabVal,
  setFilesPartsEmpty,
} from "../slice/searchPaginationSlice";

const Dashboard = () => {
  const userInfo = getLocalStorage("user")
    ? JSON.parse(getLocalStorage("user"))
    : null;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dashboardList, setDashboardList] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [schoolOnboarding, setSchoolOnboarding] = useState(false);
  const [openAgencyModal, setOpenAgencyModal] = useState(false);
  const [agencyName, setAgencyName] = useState("");
  const [agencyNameError, setAgencyNameError] = useState("");
  const [classType, setClassType] = useState(null);
  const [classTypeError, setClassTypeError] = useState(false);

  const [count, setCount] = useState(0);
  const [agencyCount, setAgencyCount] = useState(0);
  const [agencyPageNumber, setAgencyPageNumber] = useState(0);
  const [schoolPageNumber, setSchoolPageNumber] = useState(0);
  const [backDropLoading, setBackDropLoading] = useState(false);
  const [agencies, setAgencies] = useState([]);
  const [roles, setRoles] = useState([]);

  const dispatch = useDispatch();
  const { dashBoardPageNumber, dashBoardTabVal } = useSelector(
    (store) => store.searchPagination
  );
  const [value, setValue] = useState(
    userInfo?.roleId === 10 ? 2 : dashBoardTabVal
  );
  useEffect(() => {
    if (userInfo?.roleId === 10) {
      setValue(dashBoardTabVal);
    } else {
      setValue(dashBoardTabVal);
    }
  }, [dashBoardTabVal]);
  // console.log(dashBoardPageNumber, "dashBoardPageNumber");
  const [employeeData, setEmployeeData] = useState({
    email: "",
    password: "",
    agencyType: "",
    employeeName: "",
    agencyName: "",
    confirmpassword: "",
    isDownloadAllow: false,
  });
  const [errors, setErrors] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);

  const [schoolData, setSchoolData] = useState({
    name: "",
    email: "",
    password: "",
    confirmpassword: "",
    schoolCode: "",
    district: "",
    pincode: "",
    // username: "",
    mobilenumber: "",
  });
  const [schoolErrors, setSchoolErrors] = useState({});

  const handleScoolModalClose = () => {
    setSchoolOnboarding(false);
    setSchoolErrors({});
    setSchoolData({
      name: "",
      email: "",
      password: "",
      confirmpassword: "",
      schoolCode: "",
      district: "",
      pincode: "",
      // username: "",
    });
  };

  const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;
  const passwordRegex =
    /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/;

  const dashboardData = async () => {
    try {
      setBackDropLoading(true);
      const response = await api.get(
        `users/user-list?limit=50&offset=${50 * dashBoardPageNumber}`
      );
      // console.log(response, "response");

      setCount(response?.data?.data?.count);

      setDashboardList(response.data?.data?.rows);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setBackDropLoading(false);
      setLoading(false);
    }
  };

  const agencyData = async () => {
    try {
      setBackDropLoading(true);
      const response = await api.get(
        `agency/?limit=50&offset=${50 * agencyPageNumber}`
      );
      // console.log(response, "response");

      setAgencyCount(response?.data?.data?.count);
      // console.log(response.data?.data, "responsedata");
      setAgencyList(response?.data?.data?.rows);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setBackDropLoading(false);
      setLoading(false);
    }
  };

  const [schoolList, setSchoolList] = useState([]);
  const [schoolcount, setSchoolCount] = useState(0);
  const getSchoolData = async () => {
    try {
      setBackDropLoading(true);
      const response = await api.get(
        `school/?limit=50&offset=${50 * schoolPageNumber}`
      );
      // console.log(response, "response");

      setSchoolCount(response?.data?.data?.count);
      // console.log(response.data?.data, "responsedata");
      setSchoolList(response?.data?.data?.schools);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setBackDropLoading(false);
      setLoading(false);
    }
  };
  const getAllAgency = async () => {
    try {
      const response = await api.get("agency");
      if (response?.data?.success) {
        setAgencies(response?.data?.data?.rows);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (userInfo?.roleId && userInfo?.roleId == 1) {
      getAllAgency();
    }
  }, []);

  useEffect(() => {
    if (userInfo?.roleId && userInfo?.roleId == 1) {
      dashboardData();
    }
  }, [dashBoardPageNumber]);

  useEffect(() => {
    if (userInfo?.roleId && userInfo?.roleId == 1) {
      agencyData();
    }
  }, [agencyPageNumber]);
  useEffect(() => {
    getSchoolData();
  }, [schoolPageNumber]);

  const handleModalOpen = () => {
    getAllAgency();
    setOpenModal(true);
  };

  const handleSchoolOnboarding = () => {
    setSchoolOnboarding(true);
  };
  const handleAgencyModalOpen = () => {
    setOpenAgencyModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setEmployeeData({
      email: "",
      password: "",
      agencyType: "",

      employeeName: "",
      agencyName: "",
      isDownloadAllow: false,
    });
    setErrors({});
  };
  const handleAgencyModalClose = () => {
    setOpenAgencyModal(false);
    setAgencyName("");
    setAgencyNameError("");
    setClassType(null);
    setClassTypeError(false);
    // setErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmployeeData((prevData) => ({ ...prevData, [name]: value }));

    let error = "";
    if (!value.trim()) {
      error = "This field is required";
    } else if (name === "email" && !emailRegex.test(value)) {
      error = "Enter a valid email";
    } else if (name === "password" && !passwordRegex.test(value)) {
      error =
        "Password must be at least 8 characters long, include at least 1 number, 1 lowercase, 1 uppercase, and 1 special character (@#$%&)";
    } else if (name === "confirmpassword" && value !== employeeData.password) {
      error =
        "Password must be at least 8 characters long, include at least 1 number, 1 lowercase, 1 uppercase, and 1 special character (@#$%&)";
    }
    setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
  };

  const handleSchoolChange = (e) => {
    const { name, value } = e.target;
    setSchoolData((prevData) => ({ ...prevData, [name]: value }));

    let error = "";
    if (!value.trim()) {
      error = "This field is required";
    } else if (name === "email" && !emailRegex.test(value)) {
      error = "Enter a valid email";
    } else if (name === "password" && !passwordRegex.test(value)) {
      error =
        "Password must be at least 8 characters long, include at least 1 number, 1 lowercase, 1 uppercase, and 1 special character (@#$%&)";
    } else if (name === "confirmpassword" && value !== schoolData.password) {
      error =
        "Password must be at least 8 characters long, include at least 1 number, 1 lowercase, 1 uppercase, and 1 special character (@#$%&)";
    }
    // else if (name === "username" && value?.length < 6) {
    //   error = "User Name must be least 6 characters long ";
    // }
    if (name !== "email" && name !== "pincode") {
      setSchoolErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    }
  };
  const handleDropdownChange = (event) => {
    const { value } = event.target;
    if (value === "Admin") {
      setEmployeeData((prevData) => ({ ...prevData, isDownloadAllow: false }));
    }
    setErrors((prevErrors) => ({ ...prevErrors, agencyType: "" }));

    setEmployeeData((prevData) => ({ ...prevData, agencyType: value }));
  };
  // console.log(employeeData, errors, "employeeData");
  const isFormValid = () => {
    if (employeeData.agencyType === 3) {
      return (
        employeeData.agencyName &&
        employeeData.password === employeeData.confirmpassword &&
        emailRegex.test(employeeData.email) &&
        passwordRegex.test(employeeData.password) &&
        employeeData.agencyType &&
        employeeData.employeeName &&
        !errors.email &&
        !errors.password
      );
    }

    return (
      emailRegex.test(employeeData.email) &&
      passwordRegex.test(employeeData.password) &&
      employeeData.password === employeeData.confirmpassword &&
      employeeData.agencyType &&
      employeeData.employeeName &&
      !errors.email &&
      !errors.password
    );
  };

  const handleSubmit = async () => {
    if (!isFormValid()) {
      Object.keys(employeeData).map((key) => {
        if (!employeeData[key]) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [key]:
              key === "agencyType" || key === "agency Name"
                ? `Please Select ${key === "agencyType" ? "User Type" : key}`
                : key === "employeeName"
                ? "Please Enter Name "
                : `Please ${key === "agencyName" ? "" : "Select"} ${
                    key === "agencyName" ? "Agency Name" : key
                  }`,
          }));
        }
      });
      if (employeeData.password !== employeeData.confirmpassword) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          confirmpassword: "Password mismatched!",
        }));
      }

      if (employeeData.agencyType === 3 && employeeData.agencyName) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          agencyName: "",
        }));
      }
      // toast.error("Please fix the errors before submitting.");
      return;
    }

    setSubmitLoading(true);
    try {
      const response = await api.post("users", {
        email: employeeData.email.toLowerCase(),
        password: employeeData.password,
        role: employeeData.agencyType,
        name: employeeData.employeeName,
        ...(employeeData?.agencyType === 3 && {
          agencyId: employeeData?.agencyName,
        }),
        isDownloadAllow: employeeData.isDownloadAllow,
        sharedTo: [...agencyShare],
      });
      if (response?.data?.success) {
        toast.success(response?.data?.message ?? "User created successfully!");
        handleModalClose();
        setLoading(true);
        dashboardData();
      }
      if (response?.data?.success === false) {
        toast.error(response?.data?.message ?? "Error creating user!");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error creating user. Please try again."
      );
    } finally {
      setSubmitLoading(false);
    }
  };

  const isScoolFormValid = () => {
    return (
      // emailRegex.test(schoolData.email) &&
      passwordRegex.test(schoolData.password) &&
      schoolData.password === schoolData.confirmpassword &&
      schoolData.schoolCode &&
      schoolData.district &&
      // schoolData.username?.length > 5 &&
      // schoolData.pincode &&
      // !errors.email &&
      !errors.password
    );
  };

  const handleSchoolSubmit = async () => {
    if (!isScoolFormValid()) {
      Object.keys(schoolData).map((key) => {
        if (!schoolData[key]) {
          setSchoolErrors((prevErrors) => ({
            ...prevErrors,
            [key]: `Please Enter ${key}`,
          }));
        }
      });
      if (schoolData.password !== schoolData.confirmpassword) {
        setSchoolErrors((prevErrors) => ({
          ...prevErrors,
          confirmpassword: "Password mismatched!",
        }));
      }

      // toast.error("Please fix the errors before submitting.");
      return;
    }

    setSubmitLoading(true);
    try {
      const response = await api.post("school", {
        name: schoolData.name,
        schoolCode: schoolData.schoolCode,

        email: schoolData.email.toLowerCase(),
        password: schoolData.password,
        district: schoolData.district,
        pincode: schoolData.pincode,
        username: `${schoolData.schoolCode}@bseb.com`,
        mobile: schoolData.mobilenumber,
        // name: "SPS",
        // schoolCode: "SPS_1231112",
        // email: "sps2@yopmail.com",
        // password: "Test@123",
        // district: "Jaipur",
        // pincode: "876543",
        // username: "SPS_1231112@bseb.com",
      });
      if (response?.data?.success) {
        toast.success(
          response?.data?.message ?? "School created successfully!"
        );
        handleScoolModalClose();
        // setLoading(true);
        getSchoolData();
      }
      if (response?.data?.success === false) {
        toast.error(response?.data?.message ?? "Error creating School!");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ??
          "Error creating school. Please try again."
      );
    } finally {
      setSubmitLoading(false);
    }
  };

  const formatCustomDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
    return `${day}-${month}-${year} ${time}`;
  };

  const handleRowClick = (user) => {
    /*if (user?.role === "Agency1" || user?.role === "Agency2") {
      navigate(`/reports/${user?.id}`);
    }**/
    dispatch(setFilesPartsEmpty(""));
    dispatch(setDashboardSearchValue(""));

    navigate(`/reports/${user?.id}`, {
      state: {
        agencyName: user?.name,
      },
    });
  };

  const logoutUser = () => {
    clearLocalStorage();
    navigate("/login");
  };
  const handleChangePage = (event, newPage, agency) => {
    // setPage(newPage);
    if (agency) {
      setAgencyPageNumber(newPage);
      return;
    }
    dispatch(setDashBoardPageNumber(newPage));
  };

  const handleChange = (event, newValue) => {
    console.log(newValue, event, "chening");
    // setValue(newValue);
    dispatch(setDashBoardTabVal(newValue));
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  // console.log(errors, employeeData, "errors");

  const [agencyShare, setAgencyShare] = useState([]);

  const handleChangeMultiSelect = (event) => {
    const {
      target: { value },
    } = event;
    console.log(value, "value");
    setAgencyShare(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  useEffect(() => {
    setAgencyShare([]);
  }, [openModal]);
  const handleAgencySubmit = async () => {
    if (!agencyName && !classType) {
      setClassTypeError("Please Select Class Type");
      setAgencyNameError("Please Enter Agency Name");
      return;
    }
    if (!agencyName) {
      setAgencyNameError("Please Enter Agency Name");
      return;
    }
    if (!classType) {
      setClassTypeError("Please Select Class Type");
      return;
    }
    setSubmitLoading(true);

    try {
      const response = await api.post("agency/", {
        name: agencyName,
        class_type: classType,
      });

      if (response?.data?.success) {
        toast.success(
          response?.data?.message ?? "Agency created successfully!"
        );
        handleAgencyModalClose();
        // setLoading(true);
        agencyData();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ??
          "Error creating Agency. Please try again."
      );
    } finally {
      setSubmitLoading(false);
    }
  };

  const [editUSerModal, setEditUserModal] = useState(false);
  const [editUSerDetails, setEditUSerDetails] = useState({ shareTo: [] });
  const handleEditUser = (data) => {
    let shareTo = data?.consolidated_agency?.map(
      (item) => item?.access_records?.id
    );
    let newData = {
      ...data,
      shareTo: shareTo,
    };
    setEditUSerDetails(newData);
    setEditUserModal(true);
  };
  const handleEditModalClose = () => {
    setEditUserModal(false);
    setEditUSerDetails({ shareTo: [] });
  };

  const handleEditChange = (event) => {
    const {
      target: { value },
    } = event;
    console.log(value, "value");
    setEditUSerDetails({
      ...editUSerDetails,
      shareTo: typeof value === "string" ? value.split(",") : value,
    });
    // setAgencyShare(
    //   // On autofill we get a stringified value.
    //   typeof value === "string" ? value.split(",") : value
    // );
  };
  const handleEditShare = async () => {
    setSubmitLoading(true);
    try {
      const response = await api.put("agency/consolidated-agency-list", {
        // email: employeeData.email.toLowerCase(),
        // password: employeeData.password,
        // role: employeeData.agencyType,
        // name: employeeData.employeeName,
        // ...(employeeData?.agencyType === 3 && {
        //   agencyId: employeeData?.agencyName,
        // }),

        sharedTo: [...editUSerDetails?.shareTo],
        userId: editUSerDetails?.id,
      });
      if (response?.data?.success) {
        toast.success(response?.data?.message ?? "User created successfully!");
        handleEditModalClose();
        setLoading(true);
        dashboardData();
      }
      if (response?.data?.success === false) {
        toast.error(response?.data?.message ?? "Error creating user!");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error creating user. Please try again."
      );
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleViewSchool = (item) => {
    navigate(`/school-details/${item?.schoolCode}`, {
      state: { agencyName: item?.name },
    });
  };
  const [editSchoolUserDetails, setEditSchoolUserDetails] = useState({});
  const [schoolEditErrors, setSchoolEditErrors] = useState({});
  const handleSchoolEditModalClose = () => {
    setEditSchoolUserDetails({});
    setSchoolEditErrors({});
  };
  const handleEditSchoolUser = (item) => {
    console.log(item, "itemfind");
    setEditSchoolUserDetails(item);
  };

  const handleSchoolUserReport = (item) => {
    navigate(`/report-details/${item?.schoolCode ?? 0}`);
  };

  const handleEditSchoolEdit = (e) => {
    const { name, value } = e.target;
    setEditSchoolUserDetails((prevData) => ({ ...prevData, [name]: value }));
    // console.log(e, "heree");
    // let error = "";
    // if (!value.trim()) {
    //   error = "This field is required";
    // } else if (name === "password" && !passwordRegex.test(value)) {
    //   error =
    //     "Password must be at least 8 characters long, include at least 1 number, 1 lowercase, 1 uppercase, and 1 special character (@#$%&)";
    // } else if (
    //   name === "confirmpassword" &&
    //   value !== editSchoolUserDetails.password
    // ) {
    //   error =
    //     "Password must be at least 8 characters long, include at least 1 number, 1 lowercase, 1 uppercase, and 1 special character (@#$%&)";
    // }

    // setSchoolEditErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
  };
  const handleEditSchoolSubmit = async () => {
    // if (
    //   !editSchoolUserDetails.password ||
    //   !editSchoolUserDetails.confirmpassword ||
    //   !passwordRegex.test(editSchoolUserDetails.password) ||
    //   editSchoolUserDetails.password !== editSchoolUserDetails.confirmpassword
    // ) {
    //   if (
    //     editSchoolUserDetails.password !== editSchoolUserDetails.confirmpassword
    //   ) {
    //     setSchoolEditErrors((prevErrors) => ({
    //       ...prevErrors,
    //       confirmpassword: "Password mismatched!",
    //     }));
    //   }
    //   if (!editSchoolUserDetails.password) {
    //     setSchoolEditErrors((prevErrors) => ({
    //       ...prevErrors,
    //       password: "Password is required!",
    //     }));
    //   }
    //   if (!passwordRegex.test(editSchoolUserDetails.password)) {
    //     setSchoolEditErrors((prevErrors) => ({
    //       ...prevErrors,
    //       password:
    //         "Password must be at least 8 characters long, include at least 1 number, 1 lowercase, 1 uppercase, and 1 special character (@#$%&)",
    //     }));
    //   }
    //   return;
    // }
    if (!emailRegex.test(editSchoolUserDetails?.email)) {
      toast.error("Please enter proper email");
      return;
    }
    if (
      !editSchoolUserDetails?.mobile_number ||
      editSchoolUserDetails?.mobile_number?.length < 10
    ) {
      toast.error("Please enter proper mobile number");
      return;
    }
    setSubmitLoading(true);
    try {
      // const response = await api.post("users/change-password", {
      const response = await api.patch("school", {
        // email: employeeData.email.toLowerCase(),
        // password: employeeData.password,
        // role: employeeData.agencyType,
        // name: employeeData.employeeName,
        // ...(employeeData?.agencyType === 3 && {
        //   agencyId: employeeData?.agencyName,
        // }),

        // new_password: editSchoolUserDetails.password,
        // confirm_password: editSchoolUserDetails.confirmpassword,

        // userid: editSchoolUserDetails?.school_user_details?.[0]?.id,

        mobile_number: editSchoolUserDetails?.mobile_number,
        email: editSchoolUserDetails?.email,
        id: editSchoolUserDetails?.id,
      });
      if (response?.data?.success) {
        toast.success(response?.data?.message ?? "Password changed!");
        handleSchoolEditModalClose();
        setLoading(true);
        getSchoolData();

        // dashboardData();
      }
      if (response?.data?.success === false) {
        toast.error(response?.data?.message ?? "Error changing password!");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error ?? "Error changing password!");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleViewReport = () => {
    navigate("/payment-report");
  };
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={1}
        mt={2}
      >
        <Box textAlign="center">
          <img
            src="./full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" style={{ marginTop: "24px" }}>
        {/* Image Section */}
        {/* Header */}
        <Box
          display="flex"
          flexWrap="wrap"
          gap="10px"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
            }}
          >
            {userInfo?.employeeName} {""}
            Dashboard
          </Typography>
          <Box display="flex" alignItems="center" gap={2} flexWrap={"wrap"}>
            <>
              {userInfo?.roleId === 10 ? (
                <>
                  {/* <Button
                    variant="contained"
                    sx={{
                      // backgroundColor: "green",

                      color: "white",
                    }}
                    color="primary"
                    // disabled={!ids?.includes(item?.id?.toString())}
                    onClick={() => navigate("/disabled-schools")}
                    startIcon={<RemoveRedEye />}
                  >
                    Multi Students
                  </Button> */}
                  <Button
                    variant="contained"
                    sx={{
                      color: "white",
                    }}
                    color="error"
                    onClick={() => navigate("/dummy-admit-schools")}
                    startIcon={<RemoveRedEye />}
                  >
                    Dummy Admit Students
                  </Button>

                  <Button
                    variant="contained"
                    sx={{
                      // backgroundColor: "green",

                      color: "white",
                    }}
                    color="error"
                    // disabled={!ids?.includes(item?.id?.toString())}
                    onClick={() => navigate("/disabled-schools")}
                    startIcon={<RemoveRedEye />}
                  >
                    Disabled Students
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "green",

                      color: "white",
                    }}
                    // disabled={!ids?.includes(item?.id?.toString())}
                    onClick={() => handleSchoolUserReport()}
                    startIcon={<RemoveRedEye />}
                  >
                    Transactions
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "green",

                      color: "white",
                    }}
                    // disabled={!ids?.includes(item?.id?.toString())}
                    onClick={() => handleViewReport()}
                    startIcon={<RemoveRedEye />}
                  >
                    Report
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "green",

                      color: "white",
                    }}
                    // disabled={!ids?.includes(item?.id?.toString())}
                    onClick={() => navigate("/download-report")}
                    startIcon={<Download />}
                  >
                    Download Report
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Add />}
                    onClick={handleSchoolOnboarding}
                    style={{ textTransform: "none" }}
                  >
                    School
                  </Button>
                </>
              ) : value === 0 ? (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Add />}
                  onClick={handleAgencyModalOpen}
                  style={{ textTransform: "none" }}
                >
                  Create Agency
                </Button>
              ) : value === 1 ? (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Add />}
                  onClick={handleModalOpen}
                  style={{ textTransform: "none" }}
                >
                  Create User
                </Button>
              ) : userInfo?.roleId === 10 ? (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Add />}
                  onClick={handleSchoolOnboarding}
                  style={{ textTransform: "none" }}
                >
                  Create School
                </Button>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    color: "white",
                  }}
                  color="error"
                  onClick={() => navigate("/edit-user")}
                  startIcon={<Edit />}
                >
                  Edit Record
                </Button>
              )}
            </>

            <Button
              variant="contained"
              color="error"
              startIcon={<Logout />}
              onClick={logoutUser}
              style={{ textTransform: "none" }}
            >
              Logout
            </Button>
          </Box>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            {userInfo?.roleId === 10 ? (
              <Tabs
                value={0}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="SCHOOL " {...a11yProps(2)} />
              </Tabs>
            ) : (
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Agency" {...a11yProps(0)} />
                <Tab label="USER" {...a11yProps(1)} />
                <Tab label="SCHOOL " {...a11yProps(2)} />
              </Tabs>
            )}
          </Box>

          {userInfo?.roleId === 10 || value === 2 ? (
            <>
              <TableContainer
                // sx={{ maxHeight: "57vh", overflow: "auto" }}
                component={Paper}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow
                      style={{ textWrap: "nowrap", textAlign: "center" }}
                    >
                      <TableCell align="center">
                        <strong>School Code </strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>School Name</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>School Email</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Mobile</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>District</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Pin code</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>User Name</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Created At</strong>
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          position: "sticky",
                          right: 0,
                          background: "white", // Ensures it stays visible
                          zIndex: 2,
                        }}
                      >
                        <strong>Action</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {schoolList?.length > 0 ? (
                      schoolList?.map((row) => (
                        <TableRow
                          key={row?.id}
                          style={{
                            cursor: "pointer",
                            textWrap: "nowrap",
                            textAlign: "center",
                          }}
                        >
                          <TableCell align="center">
                            {row?.schoolCode ? row?.schoolCode : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.name ? row?.name : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.email ? row?.email : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.mobile_number ? row?.mobile_number : "-"}
                          </TableCell>

                          <TableCell align="center">
                            {row?.district ? row?.district : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.pincode ? row?.pincode : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.schoolCode
                              ? `${row?.schoolCode}@bseb.com`
                              : "_"}
                            {/* schoolCode
                            {row?.school_user_details?.email
                              ? row?.school_user_details?.email
                              : "-"} */}
                          </TableCell>
                          <TableCell align="center">
                            {row?.createdAt
                              ? formatCustomDate(row?.createdAt)
                              : "-"}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              position: "sticky",
                              right: 0,
                              background: "white", // Ensures it stays visible
                              zIndex: 1,
                            }}
                          >
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              onClick={() => handleViewSchool(row)}
                              style={{
                                cursor: "pointer",
                                textWrap: "nowrap",
                                textAlign: "center",
                              }}
                            >
                              View
                            </Button>
                            {userInfo?.roleId !== 10 && (
                              <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                startIcon={<Edit />}
                                onClick={() => handleEditSchoolUser(row)}
                                style={{
                                  cursor: "pointer",
                                  textWrap: "nowrap",
                                  textAlign: "center",
                                  marginLeft: "5px",
                                }}
                              >
                                Edit
                              </Button>
                            )}
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              onClick={() => handleSchoolUserReport(row)}
                              style={{
                                cursor: "pointer",
                                textWrap: "nowrap",
                                textAlign: "center",
                                marginLeft: "5px",
                              }}
                            >
                              Reports
                            </Button>
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                navigate(`/admit-card-list/${row?.schoolCode}`)
                              }
                              style={{
                                cursor: "pointer",
                                textWrap: "nowrap",
                                textAlign: "center",
                                marginLeft: "5px",
                              }}
                            >
                              Admit Card
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No Schools found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={schoolcount}
                rowsPerPage={50}
                page={schoolPageNumber}
                onPageChange={(event, newPage) =>
                  // handleChangePage(event, newPage, "agency")
                  setSchoolPageNumber(newPage)
                }
              />
            </>
          ) : value === 1 ? (
            <>
              <TableContainer
                // sx={{ maxHeight: "57vh", overflow: "auto" }}
                component={Paper}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow
                      style={{ textWrap: "nowrap", textAlign: "center" }}
                    >
                      <TableCell align="center">
                        <strong>Email</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Role</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Agency Name</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Created At</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Action</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dashboardList.length > 0 ? (
                      dashboardList.map((row) => (
                        <TableRow
                          key={row?.id}
                          style={{
                            cursor: "pointer",
                            textWrap: "nowrap",
                            textAlign: "center",
                          }}
                        >
                          <TableCell align="center">
                            {row?.email ? row?.email : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.role_details?.name
                              ? row?.role_details?.name === "School"
                                ? "School Admin"
                                : row?.role_details?.name
                              : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.agency_name?.name
                              ? row?.agency_name?.name
                              : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row?.createdAt
                              ? formatCustomDate(row?.createdAt)
                              : "-"}
                          </TableCell>
                          <TableCell align="center">
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              disabled={row?.roleId !== 3}
                              onClick={() => handleEditUser(row)}
                              // style={{
                              //   cursor: row?.roleId === 3 ? "pointer" : "help",
                              // }}
                            >
                              Edit
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No User found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={count}
                rowsPerPage={50}
                page={dashBoardPageNumber}
                onPageChange={(event, newPage) =>
                  handleChangePage(event, newPage)
                }
              />
            </>
          ) : (
            <>
              <TableContainer
                // sx={{ maxHeight: "57vh", overflow: "auto" }}
                component={Paper}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow
                      style={{ textWrap: "nowrap", textAlign: "center" }}
                    >
                      <TableCell align="center">
                        <strong>Name</strong>
                      </TableCell>

                      <TableCell align="center">
                        <strong>Created At</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Action</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {agencyList?.length > 0 ? (
                      agencyList?.map((row) => (
                        <TableRow
                          key={row?.id}
                          style={{
                            cursor: "pointer",
                            textWrap: "nowrap",
                            textAlign: "center",
                          }}
                        >
                          <TableCell align="center">
                            {row?.name ? row?.name : "-"}
                          </TableCell>

                          <TableCell align="center">
                            {row?.createdAt
                              ? formatCustomDate(row?.createdAt)
                              : "-"}
                          </TableCell>
                          <TableCell align="center">
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              onClick={() => handleRowClick(row)}
                              style={{
                                cursor: "pointer",
                                textWrap: "nowrap",
                                textAlign: "center",
                              }}
                            >
                              View Progress
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No Agency found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={agencyCount}
                rowsPerPage={50}
                page={agencyPageNumber}
                onPageChange={(event, newPage) =>
                  handleChangePage(event, newPage, "agency")
                }
              />
            </>
          )}
        </Box>

        {/* Modal for Creating Agency */}
        <Modal
          open={openModal}
          onClose={() => {
            if (!submitLoading) {
              handleModalClose();
            }
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            position="absolute"
            top="50%"
            left="50%"
            width={400}
            p={4}
            bgcolor="background.paper"
            boxShadow={24}
            borderRadius={2}
            style={{ transform: "translate(-50%, -50%)" }}
          >
            <Typography variant="h6">Create User</Typography>
            <TextField
              label="Name"
              name="employeeName"
              type="text"
              variant="outlined"
              fullWidth
              value={employeeData.employeeName}
              onChange={handleInputChange}
              error={!!errors.employeeName}
              helperText={errors.employeeName}
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              value={employeeData.email}
              onChange={handleInputChange}
              error={!!errors.email}
              helperText={errors.email}
            />

            <FormControl
              fullWidth
              variant="outlined"
              error={!!errors.agencyType}
            >
              <InputLabel>User Type</InputLabel>
              <Select
                label="User Type"
                name="agencyType"
                value={employeeData.agencyType}
                onChange={handleDropdownChange}
                helperText={errors.agencyType}
              >
                <MenuItem key={"Super Admin"} value={1}>
                  Super Admin
                </MenuItem>
                <MenuItem key={"Dao"} value={2}>
                  Dao
                </MenuItem>
                <MenuItem key={"Agency"} value={3}>
                  Agency
                </MenuItem>
                <MenuItem key={"School Admin"} value={10}>
                  School Admin
                </MenuItem>
                {/**<MenuItem key={"Agency1"} value={"Agency1"}>
                  Agency 1
                </MenuItem>
                <MenuItem key={"Agency2"} value={"Agency2"}>
                  Agency 2
                </MenuItem> */}
              </Select>
              <FormHelperText>{errors.agencyType}</FormHelperText>
            </FormControl>
            {employeeData?.agencyType == 3 && (
              <FormControl
                fullWidth
                variant="outlined"
                error={!!errors.agencyName}
              >
                <InputLabel>Agency Name</InputLabel>
                <Select
                  label="Agency Name"
                  name="agencyName"
                  value={employeeData.agencyName}
                  onChange={(e) => {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      agencyName: "",
                    }));

                    setEmployeeData({
                      ...employeeData,
                      agencyName: e.target.value,
                    });
                  }}
                  helperText={errors.agencyName}
                >
                  {agencies?.map((item) => {
                    return (
                      <MenuItem key={item?.name} value={item?.id}>
                        {item?.name}
                      </MenuItem>
                    );
                  })}

                  {/**<MenuItem key={"Agency1"} value={"Agency1"}>
                  Agency 1
                </MenuItem>
                <MenuItem key={"Agency2"} value={"Agency2"}>
                  Agency 2
                </MenuItem> */}
                </Select>
                <FormHelperText>{errors.agencyName}</FormHelperText>
              </FormControl>
            )}

            {employeeData.agencyName && (
              <FormControl
                fullWidth
                variant="outlined"
                // error={!!errors.agencyName}
              >
                <InputLabel>View Access</InputLabel>
                <Select
                  label="Share Option"
                  name="ShareOption"
                  value={agencyShare}
                  multiple
                  onChange={handleChangeMultiSelect}
                  // input={<OutlinedInput label="Tag" />}
                  MenuProps={MenuProps}
                >
                  {agencies?.map((item) => {
                    if (employeeData.agencyName !== item?.id) {
                      return (
                        <MenuItem key={item?.name} value={item?.id}>
                          <Checkbox checked={agencyShare?.includes(item?.id)} />
                          {item?.name}
                        </MenuItem>
                      );
                    }
                  })}

                  {/**<MenuItem key={"Agency1"} value={"Agency1"}>
                  Agency 1
                </MenuItem>
                <MenuItem key={"Agency2"} value={"Agency2"}>
                  Agency 2
                </MenuItem> */}
                </Select>
                {/* <FormHelperText>{errors.agencyName}</FormHelperText> */}
              </FormControl>
            )}
            <TextField
              label="Password"
              name="password"
              type="password"
              variant="outlined"
              fullWidth
              value={employeeData.password}
              onChange={handleInputChange}
              error={!!errors.password}
              helperText={errors.password}
            />
            <TextField
              label="Confirm Password"
              name="confirmpassword"
              type="password"
              variant="outlined"
              fullWidth
              value={employeeData.confirmpassword}
              onChange={handleInputChange}
              error={!!errors.confirmpassword}
              helperText={errors.confirmpassword && "Password mismatched!"}
            />
            {/* {employeeData?.agencyType == 3 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={employeeData.isDownloadAllow}
                    onChange={(e) =>
                      setEmployeeData({
                        ...employeeData,
                        isDownloadAllow: e?.target?.checked,
                      })
                    }
                    sx={{
                      "&.Mui-checked": {
                        color: "#8C0001",
                      },
                    }}
                  />
                }
                label="Allow Download"
              />
            )} */}
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="contained"
                // color="primary"
                onClick={handleSubmit}
                disabled={submitLoading}
                style={{ backgroundColor: "#8C0001" }}
              >
                {submitLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Submit"
                )}
              </Button>
              <Button
                variant="outlined"
                disabled={submitLoading}
                onClick={handleModalClose}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={editUSerModal}
          onClose={() => {
            if (!submitLoading) {
              handleEditModalClose();
            }
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            position="absolute"
            top="50%"
            left="50%"
            width={400}
            p={4}
            bgcolor="background.paper"
            boxShadow={24}
            borderRadius={2}
            style={{ transform: "translate(-50%, -50%)" }}
          >
            <Typography variant="h6">Edit User</Typography>
            <TextField
              label="Name"
              name="Name"
              type="text"
              variant="outlined"
              fullWidth
              value={editUSerDetails.name}
              disabled={true}
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              value={editUSerDetails.email}
              disabled={true}
            />

            <FormControl fullWidth variant="outlined">
              <InputLabel>User Type</InputLabel>
              <Select
                label="User Type"
                name="agencyType"
                value={editUSerDetails.roleId}
                onChange={handleDropdownChange}
                helperText={errors.agencyType}
                disabled={true}
              >
                <MenuItem key={"Agency"} value={3}>
                  Agency
                </MenuItem>
              </Select>
            </FormControl>
            {true && (
              <FormControl fullWidth variant="outlined">
                <InputLabel>Agency Name</InputLabel>
                <Select
                  label="Agency Name"
                  name="agencyName"
                  value={editUSerDetails?.agency_name?.id}
                  disabled={true}
                >
                  {agencies?.map((item) => {
                    return (
                      <MenuItem key={item?.name} value={item?.id}>
                        {item?.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}

            {true && (
              <FormControl
                fullWidth
                variant="outlined"
                // error={!!errors.agencyName}
              >
                <InputLabel>View Access </InputLabel>
                <Select
                  label="Share Option"
                  name="ShareOption"
                  value={editUSerDetails?.shareTo}
                  multiple
                  onChange={handleEditChange}
                  // input={<OutlinedInput label="Tag" />}
                  MenuProps={MenuProps}
                >
                  {agencies?.map((item) => {
                    if (editUSerDetails.agency_name?.id !== item?.id) {
                      return (
                        <MenuItem key={item?.name} value={item?.id}>
                          <Checkbox
                            checked={editUSerDetails?.shareTo.includes(
                              item?.id
                            )}
                          />
                          {item?.name}
                        </MenuItem>
                      );
                    }
                  })}
                </Select>
              </FormControl>
            )}

            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="contained"
                // color="primary"
                onClick={handleEditShare}
                disabled={submitLoading}
                style={{ backgroundColor: "#8C0001" }}
              >
                {submitLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Submit"
                )}
              </Button>
              <Button
                variant="outlined"
                disabled={submitLoading}
                onClick={handleEditModalClose}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal open={openAgencyModal} onClose={handleAgencyModalClose}>
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            position="absolute"
            top="50%"
            left="50%"
            width={400}
            p={4}
            bgcolor="background.paper"
            boxShadow={24}
            borderRadius={2}
            style={{ transform: "translate(-50%, -50%)" }}
          >
            <Typography variant="h6">Create Agency</Typography>

            <TextField
              label="Agency Name"
              name="employeeName"
              type="text"
              variant="outlined"
              fullWidth
              value={agencyName}
              onChange={(e) => {
                setAgencyName(e.target.value);
                setAgencyNameError("");
              }}
              error={!!agencyNameError}
              helperText={agencyNameError && "Please Enter Agency Name"}
            />
            <FormControl fullWidth variant="outlined" error={classTypeError}>
              <InputLabel>Class Type</InputLabel>
              <Select
                label="classType"
                name="classType"
                value={classType}
                onChange={(e) => {
                  setClassType(e.target.value);
                  setClassTypeError(false);
                }}
                helperText={classTypeError}
              >
                <MenuItem key={"Matric"} value={2}>
                  Matric
                </MenuItem>
                <MenuItem key={"Inter"} value={1}>
                  Inter
                </MenuItem>
                <MenuItem key={"Both"} value={3}>
                  Both
                </MenuItem>
                {/**<MenuItem key={"Agency1"} value={"Agency1"}>
                  Agency 1
                </MenuItem>
                <MenuItem key={"Agency2"} value={"Agency2"}>
                  Agency 2
                </MenuItem> */}
              </Select>
              <FormHelperText>{classTypeError}</FormHelperText>
            </FormControl>
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="contained"
                // color="primary"
                onClick={handleAgencySubmit}
                disabled={submitLoading}
                style={{ backgroundColor: "#8C0001" }}
              >
                {submitLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Submit"
                )}
              </Button>
              <Button
                variant="outlined"
                onClick={handleAgencyModalClose}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={schoolOnboarding}
          onClose={() => {
            if (!submitLoading) {
              handleScoolModalClose();
            }
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            position="absolute"
            top="50%"
            left="50%"
            width={400}
            p={4}
            bgcolor="background.paper"
            boxShadow={24}
            borderRadius={2}
            style={{ transform: "translate(-50%, -50%)" }}
            sx={{
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <Typography variant="h6">Create School</Typography>
            <TextField
              label="School Code"
              name="schoolCode"
              type="text"
              variant="outlined"
              fullWidth
              value={schoolData.schoolCode}
              onChange={handleSchoolChange}
              error={!!schoolErrors.schoolCode}
              helperText={schoolErrors.schoolCode}
              required
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} // Ensures only numeric input
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
              }}
            />
            <TextField
              label="School Name"
              name="name"
              type="text"
              variant="outlined"
              fullWidth
              value={schoolData.name}
              onChange={handleSchoolChange}
              error={!!schoolErrors.name}
              helperText={schoolErrors.name}
              required
            />
            <TextField
              label="School Email"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              value={schoolData.email}
              onChange={handleSchoolChange}
              // error={!!schoolErrors.email}
              // helperText={schoolErrors.email}
            />
            <TextField
              label="Mobile Number"
              name="mobilenumber"
              type="text"
              variant="outlined"
              fullWidth
              value={schoolData.mobilenumber}
              onChange={handleSchoolChange}
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} // Ensures only numeric input
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
              }}
              // error={!!schoolErrors.email}
              // helperText={schoolErrors.email}
            />

            <TextField
              label="District"
              name="district"
              type="text"
              variant="outlined"
              fullWidth
              value={schoolData.district}
              onChange={handleSchoolChange}
              error={!!schoolErrors.district}
              helperText={schoolErrors.district}
              required
            />
            <TextField
              label="Pin Code"
              name="pincode"
              type="text"
              variant="outlined"
              fullWidth
              value={schoolData.pincode}
              onChange={handleSchoolChange}
              // error={!!schoolErrors.pincode}
              // helperText={schoolErrors.pincode}
            />
            <TextField
              label="User Name"
              name="username"
              type="text"
              variant="outlined"
              placeholder="schoolcode@bseb.com"
              fullWidth
              value={
                schoolData.schoolCode ? `${schoolData.schoolCode}@bseb.com` : ""
              }
              // onChange={handleSchoolChange}
              disabled
              required
              // error={!!schoolErrors.username}
              // helperText={schoolErrors.username}
              // InputProps={{
              //   endAdornment: (
              //     <InputAdornment position="end">@bseb.com</InputAdornment>
              //   ),
              // }}
            />

            <TextField
              label="Password"
              name="password"
              type="password"
              variant="outlined"
              fullWidth
              value={schoolData.password}
              onChange={handleSchoolChange}
              error={!!schoolErrors.password}
              helperText={schoolErrors.password}
              required
            />
            <TextField
              label="Confirm Password"
              name="confirmpassword"
              type="password"
              variant="outlined"
              fullWidth
              value={schoolData.confirmpassword}
              onChange={handleSchoolChange}
              error={!!schoolErrors.confirmpassword}
              helperText={
                schoolErrors.confirmpassword && "Password mismatched!"
              }
              required
            />

            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="contained"
                // color="primary"
                onClick={handleSchoolSubmit}
                disabled={submitLoading}
                style={{ backgroundColor: "#8C0001" }}
              >
                {submitLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Submit"
                )}
              </Button>
              <Button
                variant="outlined"
                disabled={submitLoading}
                onClick={handleScoolModalClose}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={editSchoolUserDetails?.id}
          onClose={() => {
            if (!submitLoading) {
              handleSchoolEditModalClose({});
            }
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            position="absolute"
            top="50%"
            left="50%"
            width={400}
            p={4}
            bgcolor="background.paper"
            boxShadow={24}
            borderRadius={2}
            style={{ transform: "translate(-50%, -50%)" }}
            sx={{
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <Typography variant="h6">Edit School User</Typography>
            <TextField
              label="School Code"
              name="schoolCode"
              type="text"
              variant="outlined"
              fullWidth
              value={editSchoolUserDetails.schoolCode}
              disabled
            />
            <TextField
              label="School Name"
              name="name"
              type="text"
              variant="outlined"
              fullWidth
              value={editSchoolUserDetails.name}
              disabled
            />

            <TextField
              label="User Name"
              name="username"
              type="text"
              variant="outlined"
              fullWidth
              value={editSchoolUserDetails?.school_user_details?.[0]?.email}
              disabled
              // InputProps={{
              //   endAdornment: (
              //     <InputAdornment position="end">@bseb.com</InputAdornment>
              //   ),
              // }}
            />
            <TextField
              label="Email"
              name="email"
              type="text"
              variant="outlined"
              fullWidth
              value={editSchoolUserDetails?.email}
              // disabled
              // InputProps={{
              //   endAdornment: (
              //     <InputAdornment position="end">@bseb.com</InputAdornment>
              //   ),
              // }}
              onChange={handleEditSchoolEdit}
            />
            <TextField
              label="Mobile "
              name="mobile_number"
              type="text"
              variant="outlined"
              fullWidth
              value={editSchoolUserDetails?.mobile_number}
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} // Ensures only numeric input
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
              }}
              onChange={handleEditSchoolEdit}
            />

            {/* <TextField
              label="New Password"
              name="password"
              type="password"
              variant="outlined"
              fullWidth
              value={editSchoolUserDetails.password}
              onChange={handleEditSchoolEdit}
              error={!!schoolEditErrors.password}
              helperText={schoolEditErrors.password}
              required
            />
            <TextField
              label="Confirm Password"
              name="confirmpassword"
              type="password"
              variant="outlined"
              fullWidth
              value={editSchoolUserDetails.confirmpassword}
              onChange={handleEditSchoolEdit}
              error={!!schoolEditErrors.confirmpassword}
              helperText={
                schoolEditErrors.confirmpassword && "Password mismatched!"
              }
              required
            /> */}

            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="contained"
                // color="primary"
                onClick={handleEditSchoolSubmit}
                disabled={submitLoading}
                style={{ backgroundColor: "#8C0001" }}
              >
                {submitLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Update"
                )}
              </Button>
              <Button
                variant="outlined"
                disabled={submitLoading}
                onClick={handleSchoolEditModalClose}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>
      </Container>
      <Backdrop open={backDropLoading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Dashboard;
